import React from 'react'

export default function Step3Asset (props) {
  return (
    <svg
      width="365"
      height="147"
      viewBox="0 0 365 147"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <rect y="36" width="365" height="111" fill="#FFF9D6" />
      <circle cx="193.86" cy="98.6496" r="22.3503" fill="#E2C508" />
      <path
        d="M248.658 0L193.859 53.949L238.873 98.6497L293.28 44.4508L248.658 0Z"
        fill="#D3B200"
      />
      <path
        d="M193.86 53.9492C218.547 53.9492 238.561 73.9624 238.561 98.6499V98.6499L193.86 98.6499L193.86 53.9492V53.9492Z"
        fill="#ECCAAF"
      />
      <path
        d="M193.861 76.2993C206.204 76.2993 216.211 86.3059 216.211 98.6496V98.6496L193.861 98.6496L193.861 76.2993V76.2993Z"
        fill="#1D1F21"
      />
      <path
        d="M85 85.6105C97.2863 85.6105 108.219 76.5021 116.432 69.2816C119.353 66.7139 129.018 56.1872 117.421 59.7162C106.503 63.0389 83.1594 99.5239 104.783 99.5239C110.398 99.5239 115.016 98.5454 118.63 95.8523C122.245 93.1593 124.804 87.8205 125.499 90.4899C126.195 93.1593 126.195 94.1515 128.522 96.9152C130.848 99.6788 136.069 100.394 138.468 100.394C140.867 100.394 142.603 100.188 145.337 97.7847C147.525 95.8615 147.863 96.4466 150.338 97.3983C156.841 99.8998 169.123 104.424 176 100.394"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="square"
      />
      <path d="M39 110L326 110" stroke="#1D1F21" strokeWidth="2" />
    </svg>
  )
}
